export default __webpack_public_path__ + "static/media/star-full-white.a3303e9c.svg";